module.exports = __webpack_public_path__ + "static/media/9.e43f55ff.png";